<div class="mt-2">

  <!-- RANGE TABS -->

  <mat-tab-group
    animationDuration="0ms"
    class="mt-2"
    (selectedTabChange)="selectedTabChange($event)"
  >

    <mat-tab label="Last 4 Hrs"></mat-tab>
    <mat-tab label="Last 24 Hrs"></mat-tab>
    <mat-tab label="Last 7 Days"></mat-tab>
    <mat-tab label="This Month"></mat-tab>
    <mat-tab label="Last Month"></mat-tab>

  </mat-tab-group>


  <!-- TABLE -->

  <div class="mt-3 position-relative">

    <table
      mat-table
      [dataSource]="_dataSource"
      class="mat-elevation-z8 w-100"
    >

      <!-- Timestamp -->

      <ng-container matColumnDef="Timestamp">

        <th mat-header-cell *matHeaderCellDef>
          Date Processed
        </th>

        <td mat-cell *matCellDef="let row">
          {{ row.timestamp | date:'MMM d, y h:mm a' }}
        </td>

      </ng-container>


      <!-- Type -->

      <ng-container matColumnDef="Type">

        <th mat-header-cell *matHeaderCellDef>
          Type
        </th>

        <td mat-cell *matCellDef="let row">

          <span class="badge badge-info">
            {{ row.type }}
          </span>

        </td>

      </ng-container>


      <!-- State -->

      <ng-container matColumnDef="State">

        <th mat-header-cell *matHeaderCellDef>
          State
        </th>

        <td mat-cell *matCellDef="let row">

          <ng-container
            *ngFor="let item of row.state | keyvalue"
          >

            <span
              class="badge"
              [ngClass]="
                item.value
                  ? 'color-success'
                  : 'color-danger'
              "
            >
              {{ item.key }} :
              {{ item.value ? 'Up' : 'Down' }}
            </span>

          </ng-container>

        </td>

      </ng-container>


      <!-- Details -->

      <ng-container matColumnDef="Details">

        <th mat-header-cell *matHeaderCellDef>
          Details
        </th>

        <td mat-cell *matCellDef="let row">

          <div>
            <strong>ID:</strong>
            {{ row.details?.transactionId }}
          </div>

          <div>

            <strong>Status:</strong>

            <span
              class="badge"
              [ngClass]="{
                'color-success':
                  row.details?.status === 'Sent',
                'color-warning':
                  row.details?.status === 'Pending',
                'color-danger':
                  row.details?.status === 'Failed'
              }"
            >
              {{ row.details?.status }}
            </span>

          </div>

        </td>

      </ng-container>


      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns"
      ></tr>

      <tr
        mat-row
        *matRowDef="
          let row;
          columns: displayedColumns
        "
      ></tr>

    </table>


    <!-- PAGINATOR -->

    <mat-paginator [length]="length" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    (page)="pageEvent = $event" (page)="handlePageEvent($event)" [hidden]="!selfSort && !length"></mat-paginator>

  </div>

</div>